export default __webpack_public_path__ + "static/media/b-10.072a8de6.png";